document.addEventListener('DOMContentLoaded', () => {
  const selector = '.reveal-on-scroll';

  // Skip if user prefers reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(selector).forEach(el => el.classList.add('is-revealed'));
    return;
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      io.unobserve(entry.target); // animate once
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -10% 0px' // start a bit before they fully enter
  });

  // Observe current matching sections
  document.querySelectorAll(selector).forEach(el => io.observe(el));

  // Re-bind for dynamically loaded sections (theme editor / section renders)
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target?.closest('.shopify-section') || e.target;
    if (!sec) return;
    if (sec.matches(selector)) io.observe(sec);
    sec.querySelectorAll(selector).forEach(el => io.observe(el));
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Helper: prepare children of any .reveal-children container
  function primeChildren(container, stepMs = 140) {
    const kids = Array.from(container.querySelectorAll(':scope > *')); // 3 columns
    kids.forEach((el, i) => {
      el.classList.add('reveal-on-scroll');
      el.style.setProperty('--reveal-delay', (i * stepMs) + 'ms');
      if (prefersReduced) el.classList.add('is-revealed');
    });
    return kids;
  }

  if (prefersReduced) {
    document.querySelectorAll('.reveal-children').forEach(sec => primeChildren(sec, 0));
    return;
  }

  // Observe each child individually
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

  // Prime and observe on first load
  document.querySelectorAll('.reveal-children').forEach(sec => {
    primeChildren(sec); // sets delays
    sec.querySelectorAll(':scope > *').forEach(child => io.observe(child));
  });

  // Re-prime on section hot-reload in the editor
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target?.closest('.reveal-children') || e.target;
    if (!sec || !sec.matches('.reveal-children')) return;
    primeChildren(sec);
    sec.querySelectorAll(':scope > *').forEach(child => io.observe(child));
  });
});

